import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import {
  HorseClass,
  RecordingClass,
  SharedAnalysisResults,
  SharedAnalysisResultsResponse,
} from '@sleipai/sleip-models';
import { Observable, distinctUntilChanged, from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedAnalysisResultsService {
  constructor(private functions: Functions) {}

  loadSharedAnalysisResultsByIdAndKey(
    publicRecordingId: string,
    publicKey: string,
    version: string = 'v2'
  ): Observable<SharedAnalysisResultsResponse> {
    const paramData = { publicRecordingId, key: publicKey, version };

    const sharedAnalysisResultsCallable = httpsCallable(
      this.functions,
      'publicSharedRecordingsApi-get'
    );

    const sharedAnalysisResultsObs$ = from(
      sharedAnalysisResultsCallable(paramData)
    );

    const combinedData$ = sharedAnalysisResultsObs$.pipe(
      distinctUntilChanged(),
      map((response) => response.data as SharedAnalysisResultsResponse),
      map((sharedAnalysisResultsResponse) => {
        const userType = sharedAnalysisResultsResponse.userType;
        const detail = sharedAnalysisResultsResponse.detail.map(
          (sharedAnalysisResults) => {
            const { analysisResults, horse, recording } = sharedAnalysisResults;
            const analysisResultWithoutStrides = {
              ...analysisResults,
            };

            const parsedHorse = new HorseClass({
              id: horse.horseId,
              ...horse,
            });

            const parsedRecording = new RecordingClass({
              id: recording.recordingId,
              ...recording,
            });

            return {
              ...sharedAnalysisResults,
              analysisResults: analysisResultWithoutStrides,
              horse: parsedHorse,
              recording: parsedRecording,
              publicSharedRecordingId: publicRecordingId,
              publicKey,
            } as SharedAnalysisResults;
          }
        );
        return {
          detail,
          userType,
        };
      })
    );

    return combinedData$;
  }
}
